
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { EventManager } from "@/components/EventManager";
import { EventList } from "@/components/dashboard/events/EventList";

export const EventsPage = () => {
  const [isCreating, setIsCreating] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-3xl font-bold">Events</h2>
        <Button onClick={() => setIsCreating(true)}>
          <Plus className="mr-2 h-4 w-4" />
          Create Event
        </Button>
      </div>

      {isCreating ? (
        <div className="max-w-2xl mx-auto">
          <EventManager onCancel={() => setIsCreating(false)} />
        </div>
      ) : (
        <EventList />
      )}
    </div>
  );
};
